<div class="container-fluid">
  <div class="page-title">
    <div class="row">
      <div class="col-6">
        <h3>Empresas</h3>
      </div>
      <div class="col-6">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a routerLink="/dashboard/default">
              <i class="feather icon-home"></i>
              Painel
            </a>
          </li>
          <li class="breadcrumb-item active">Empresas</li>
        </ol>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h5>
            <i class="feather icon-briefcase"></i>
            Empresas Vinculadas
          </h5>
          <div class="card-header-right">
            <div class="stats-info">
              <span class="stats-number">{{ totalItems }}</span>
              <span class="stats-label">Empresas</span>
            </div>
            <button
              class="btn btn-outline-primary btn-sm ms-3"
              (click)="toggleFiltros()"
            >
              <i class="feather icon-filter"></i>
              {{ mostrarFiltros ? "Ocultar" : "Filtros" }}
            </button>
          </div>
        </div>

        <div class="card-body">
          <div *ngIf="loading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Carregando...</span>
            </div>
            <p class="mt-3">Carregando empresas...</p>
          </div>

          <div
            *ngIf="!loading && empresas.length === 0"
            class="text-center py-5"
          >
            <div class="empty-state">
              <i class="feather icon-briefcase empty-icon"></i>
              <h4>Nenhuma empresa encontrada</h4>
              <p>Você ainda não possui empresas cadastradas.</p>
            </div>
          </div>

          <div *ngIf="!loading && empresas.length > 0" class="companies-grid">
            <div class="row">
              <div
                *ngFor="let empresa of empresas"
                class="col-xl-6 col-lg-6 col-md-12 mb-4"
              >
                <div class="company-card">
                  <div class="company-header">
                    <div class="company-info">
                      <h6 class="company-name">{{ empresa.nome }}</h6>
                      <p class="company-fantasy" *ngIf="empresa.nome_fantasia">
                        {{ empresa.nome_fantasia }}
                      </p>
                    </div>
                    <div class="company-status">
                      <div
                        class="status-badge"
                        [ngClass]="
                          empresaService.getStatusClass(empresa.status)
                        "
                      >
                        <i
                          [ngClass]="
                            empresaService.getStatusIcon(empresa.status)
                          "
                        ></i>
                        {{ empresaService.getStatusText(empresa.status) }}
                      </div>
                    </div>
                  </div>

                  <div class="company-details">
                    <div class="detail-row">
                      <div class="detail-item">
                        <i class="feather icon-file-text"></i>
                        <span class="detail-label">CNPJ:</span>
                        <span class="detail-value">{{
                          empresaService.formatarCNPJ(empresa.cnpj)
                        }}</span>
                      </div>
                      <div class="detail-item">
                        <i class="feather icon-percent"></i>
                        <span class="detail-label">Comissão:</span>
                        <span class="detail-value">{{
                          empresaService.formatarComissao(
                            empresa.comissao_representante
                          )
                        }}</span>
                      </div>
                    </div>

                    <div class="detail-row">
                      <div class="detail-item">
                        <i class="feather icon-map-pin"></i>
                        <span class="detail-label">Localização:</span>
                        <span class="detail-value"
                          >{{ empresa.cidade || "N/A" }}/{{
                            empresa.uf || "N/A"
                          }}</span
                        >
                      </div>
                      <div class="detail-item">
                        <i class="feather icon-phone"></i>
                        <span class="detail-label">Telefone:</span>
                        <span class="detail-value">{{
                          empresaService.formatarTelefone(empresa.telefone)
                        }}</span>
                      </div>
                    </div>

                    <div class="detail-row">
                      <div class="detail-item full-width">
                        <i class="feather icon-mail"></i>
                        <span class="detail-label">Email:</span>
                        <span class="detail-value">{{
                          empresa.email || "N/A"
                        }}</span>
                      </div>
                    </div>

                    <div class="detail-row">
                      <div
                        class="detail-item full-width"
                        style="margin-left: 25px"
                      >
                        <span class="detail-label">Endereço:</span>
                        <div class="detail-value address-container">
                          <ng-container
                            *ngIf="
                              empresa.rua || empresa.numero || empresa.bairro;
                              else enderecoNaoInformado
                            "
                          >
                            <div class="address-line">
                              <i class="feather icon-map-pin"></i>
                              {{
                                empresaService.formatarEnderecoCompleto(empresa)
                                  .rua
                              }}
                            </div>
                            <div
                              class="address-line cep-line"
                              *ngIf="
                                empresaService.formatarEnderecoCompleto(empresa)
                                  .cep
                              "
                            >
                              <i class="feather icon-mail"></i>
                              CEP:
                              {{
                                empresaService.formatarEnderecoCompleto(empresa)
                                  .cep
                              }}
                            </div>
                          </ng-container>
                          <ng-template #enderecoNaoInformado>
                            <span class="text-muted">
                              <i class="feather icon-alert-circle"></i>
                              Endereço não informado
                            </span>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="company-actions">
                    <button
                      class="btn btn-outline-primary btn-sm"
                      (click)="abrirDetalhes(empresa)"
                    >
                      <i class="feather icon-eye"></i>
                      Ver Detalhes
                    </button>
                    <!-- <button
                      class="btn btn-outline-secondary btn-sm"
                      (click)="abrirModalEditarStatus(empresa)"
                    >
                      <i class="feather icon-edit"></i>
                      Editar
                    </button> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Pagination -->
          <div *ngIf="!loading && totalPages > 1" class="pagination-container">
            <nav aria-label="Navegação de páginas">
              <ul class="pagination justify-content-center">
                <li
                  class="page-item"
                  [ngClass]="{ disabled: currentPage === 1 }"
                >
                  <a
                    class="page-link"
                    href="javascript:void(0)"
                    (click)="onPageChange(currentPage - 1)"
                    [class.disabled]="currentPage === 1"
                  >
                    <i class="feather icon-chevron-left"></i>
                    Anterior
                  </a>
                </li>

                <li
                  *ngFor="let page of getPageNumbers()"
                  class="page-item"
                  [ngClass]="{ active: page === currentPage }"
                >
                  <a
                    class="page-link"
                    href="javascript:void(0)"
                    (click)="onPageChange(page)"
                  >
                    {{ page }}
                  </a>
                </li>

                <li
                  class="page-item"
                  [ngClass]="{ disabled: currentPage === totalPages }"
                >
                  <a
                    class="page-link"
                    href="javascript:void(0)"
                    (click)="onPageChange(currentPage + 1)"
                    [class.disabled]="currentPage === totalPages"
                  >
                    Próximo
                    <i class="feather icon-chevron-right"></i>
                  </a>
                </li>
              </ul>
            </nav>

            <div class="pagination-info text-center mt-3">
              <small class="text-muted">
                Página {{ currentPage }} de {{ totalPages }} ({{ totalItems }}
                empresas no total)
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de Filtros -->
  <div class="filtros-modal" [class.show]="mostrarFiltros">
    <div class="filtros-overlay" (click)="toggleFiltros()"></div>
    <div class="filtros-panel">
      <div class="filtros-header">
        <h5 class="filtros-title">
          <i class="feather icon-filter"></i>
          Filtros de Busca
        </h5>
        <button class="filtros-close" (click)="toggleFiltros()">
          <i class="icofont icofont-close"></i>
        </button>
      </div>

      <div class="filtros-content">
        <form (ngSubmit)="aplicarFiltros()" #filtrosForm="ngForm">
          <div class="filtros-grid">
            <div class="filtro-item">
              <label class="form-label">Nome da Empresa</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="filtros.nome"
                name="nome"
                placeholder="Digite o nome..."
              />
            </div>

            <div class="filtro-item">
              <label class="form-label">Nome Fantasia</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="filtros.nome_fantasia"
                name="nome_fantasia"
                placeholder="Digite o nome fantasia..."
              />
            </div>

            <div class="filtro-item">
              <label class="form-label">CNPJ</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="filtros.cnpj"
                name="cnpj"
                placeholder="Digite o CNPJ..."
              />
            </div>

            <div class="filtro-item">
              <label class="form-label">Status</label>
              <select
                class="form-select"
                [(ngModel)]="filtros.status"
                name="status"
              >
                <option [ngValue]="''">Todos os status</option>
                <option [ngValue]="'1'">Ativo</option>
                <option [ngValue]="'0'">Inativo</option>
              </select>
            </div>

            <div class="filtro-item">
              <label class="form-label">Cidade</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="filtros.cidade"
                name="cidade"
                placeholder="Digite a cidade..."
              />
            </div>

            <div class="filtro-item">
              <label class="form-label">UF</label>
              <select class="form-select" [(ngModel)]="filtros.uf" name="uf">
                <option [ngValue]="''">Todos os estados</option>
                <option *ngFor="let uf of ufs" [value]="uf.sigla">
                  {{ uf.nome }}
                </option>
              </select>
            </div>

            <div class="filtro-item">
              <label class="form-label">Telefone</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="filtros.telefone"
                name="telefone"
                placeholder="Digite o telefone..."
              />
            </div>

            <div class="filtro-item">
              <label class="form-label">Email</label>
              <input
                type="email"
                class="form-control"
                [(ngModel)]="filtros.email"
                name="email"
                placeholder="Digite o email..."
              />
            </div>
          </div>

          <div class="filtros-actions">
            <button type="submit" class="btn btn-primary">
              <i class="feather icon-search"></i>
              Buscar Empresas
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary"
              (click)="limparFiltros()"
            >
              <i class="feather icon-refresh-cw"></i>
              Limpar Filtros
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <app-empresa-detalhe-modal
    [empresa]="empresaSelecionada"
    [aberto]="modalAberta"
    (fechar)="fecharModal()"
  ></app-empresa-detalhe-modal>
  <app-editar-status-modal
    [aberto]="modalEditarStatusAberta"
    [statusAtual]="empresaParaEditar?.status"
    (salvar)="salvarStatusEmpresa($event)"
    (fechar)="fecharModalEditarStatus()"
  ></app-editar-status-modal>
</div>
